import { encodeValue } from "../..";

interface Node<T = unknown> {
	readonly node?: T | null;
}

export interface Connection<T = unknown> {
	edges?: ReadonlyArray<Node<T>> | null;
}

/**
 * This hook normalizes a relay connection to a simple array
 * of the nodes
 */
export function getConnection<T = unknown>(data: Connection<T> | undefined | null): T[] {
	const items: T[] = [];
	const edges = data?.edges ?? [];

	for (const edge of edges) {
		if (edge.node) items.push(edge.node);
	}

	return items;
}

const PREFIX = "arrayconnection:";

/**
 * Creates the cursor string from an offset.
 */
export function offsetToCursor(offset: number): string {
	return encodeValue(PREFIX + offset.toString());
}
